import React from 'react';
import Exclamation from '@johnlewispartnership/wtr-ingredients/dist/Icon/Exclamation';
import { LinkAsButton } from '@johnlewispartnership/wtr-ingredients/ingredients/LinkAsButton';
import { Typography } from '@johnlewispartnership/wtr-ingredients/foundations/typography';
import styles from './index.module.scss';
const ClosedCompetition = () => (React.createElement("div", { className: styles.card },
    React.createElement(Exclamation, { className: styles.icon }),
    React.createElement("div", { className: styles.spacer, "data-testid": "competition-ended-title" },
        React.createElement(Typography, { styleAs: "screenHeading", element: "h3" }, "Sorry, competition is now closed.")),
    React.createElement("div", { className: styles.spacer },
        React.createElement(Typography, { styleAs: "paragraph", element: "p" }, "But don't worry \u2013 we've other competitions for you to enter")),
    React.createElement("div", { className: styles.spacer },
        React.createElement(LinkAsButton, { label: "View all competitions", href: "/ecom/content/competitions", theme: "primary", width: "standard" }))));
export default ClosedCompetition;
//# sourceMappingURL=index.js.map